/**
 * 创建表格列
 * @param label 列名
 * @param prop 绑定字段
 * @param width 宽
 * @param align 对齐方式
 * @param otherProp 其他属性
 * @returns 表格列项
 */
export function createTableColumn(label?: string, prop?: string, width?: string, align?: 'left' | 'center' | 'right', otherProp?: TableColumnProp) {
  return {
    label,
    prop,
    width,
    align,
    ...otherProp
  }
}

/**
 * 常见表格插槽
 * @param label 列名
 * @param slot 插槽
 * @param otherProp 其他属性
 * @returns 
 */
export function createTableColumnSlot(label: string, slot: string | ((row: any, column: any, index: number) => VNode), otherProp?: TableColumnProp) {
  const prop: TableColumnProp = {
    label,
    slot,
    ...(otherProp || {})
  }
  return prop
}

/**
 * 创建表格操作项
 * @param text 文本
 * @param icon 图标
 * @param handler 处理方法
 * @returns 
 */
export function createTableActionItem(text: string, icon: string, handler: (row: any, tableData: any) => void,authority: string = '') {
  return {
    text,
    icon,
    handler,
    authority
  }
}

/**
 * 创建表格头部按钮
 * @param text 文本
 * @param type 类型
 * @param icon 图标
 * @param handler 处理方法
 * @returns 
 */
export function createTableHeaderButton(
  text: string,
  type: 'primary' | 'default' | 'success' | 'info' | 'warning' | 'danger',
  icon: string,
  handler: (selectRow: any[], tableData: any[]) => void,
  authority?: string
) {
  return {
    text,
    icon,
    type,
    handler,
    authority
  }
}

/**
 * 表格行编辑按钮
 * @param handler 处理方法
 * @param text 按钮文本
 * @returns 
 */
export function tableEditController(handler: TableControllerHandler, text = '编辑',authority='') {
  return createTableActionItem(text, 'Edit', handler, authority)
}

/**
 * 表格行新增按钮
 * @param handler 处理方法
 * @param text 按钮文本
 * @returns 
 */
export function tableAddController(handler: TableControllerHandler, text = '新增',authority='') {
  return createTableActionItem(text, 'Plus', handler, authority)
}

/**
 * 表格删除按钮
 * @param handler 处理方法
 * @param text 按钮文本
 * @returns 
 */
export function tableDeleteController(handler: TableControllerHandler, text = '删除',authority='') {
  return createTableActionItem(text, 'Delete', handler, authority)
}

/**
 * 表格行查看按钮
 * @param handler 处理方法
 * @param text 按钮文本
 * @returns 
 */
export function tableViewController(handler: TableControllerHandler, text = '查看',authority='') {
  return createTableActionItem(text, 'View', handler, authority)
}

/**
 * 表格行编辑按钮
 * @param handler 处理方法
 * @param text 按钮文本
 * @returns 
 */
export function tableEditHeader(handler: TableControllerHandler, text = '编辑',authority='') {
  return createTableHeaderButton(text, 'primary', 'Edit', handler, authority)
}

/**
 * 表格行新增按钮
 * @param handler 处理方法
 * @param text 按钮文本
 * @returns 
 */
export function tableAddHeader(handler: TableControllerHandler, text = '新增',authority='') {
  return createTableHeaderButton(text, 'primary', 'Plus', handler, authority)
}

/**
 * 表格删除按钮
 * @param handler 处理方法
 * @param text 按钮文本
 * @returns 
 */
export function tableDeleteHeader(handler: TableControllerHandler, text = '删除',authority='') {
  return createTableHeaderButton(text, 'primary', 'Delete', handler, authority)
}

/**
 * 表格导入按钮
 * @param handler 处理方法
 * @param text 按钮文本
 * @returns 
 */
 export function tableImportHeader(handler: TableControllerHandler, text = '导入',authority='') {
  return createTableHeaderButton(text, 'success', 'Upload', handler, authority)
}

/**
 * 表格导出按钮
 * @param handler 处理方法
 * @param text 按钮文本
 * @returns 
 */
 export function tableExportHeader(handler: TableControllerHandler, text = '导出',authority='') {
  return createTableHeaderButton(text, 'success', 'Download', handler, authority)
}